import useEventListener from "./useEventListener";
import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";
import { isBrowser } from "../helpers/isBrowser";

export function setDocumentVw() {
  if (isBrowser()) {
    const vw = document.documentElement.clientWidth / 100;
    const vh = document.documentElement.clientHeight / 100;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  return () => {};
}

export default function useCSSUnits() {
  useEventListener("resize", setDocumentVw);
  useEventListener("orientationchange", setDocumentVw);
  useEventListener("DOMContentLoaded", setDocumentVw);
  setDocumentVw();

  useIsomorphicLayoutEffect(setDocumentVw);
}
